import { Box } from '@palmetto/palmetto-components';
import { useEffect } from 'react';
import { NavLink, Route, Routes, useNavigate, useParams } from 'react-router-dom';

import { AdderType, ProgramType, adderMap } from 'types';

import { PriceCap } from './PriceCap';

export const PriceCaps = () => {
  const navigate = useNavigate();
  const { programType = ProgramType.energyBackup, priceCapType } = useParams<{
    programType: string;
    priceCapType: string;
  }>();
  useEffect(() => {
    if (!priceCapType) {
      const priceCapKey = Object.keys(adderMap[programType as ProgramType])[0] as AdderType;
      navigate(`${priceCapKey}`);
    }
  }, [priceCapType, navigate, programType]);

  return (
    <Box direction="row" childGap="3xl">
      <Box>
        {Object.keys(adderMap[programType as ProgramType]).map((type) => (
          <NavLink
            to={`/admin/pricing/${programType}/price-caps/${type}`}
            style={{ textDecoration: 'none', fontWeight: '500' }}
            key={type}
            end
          >
            {({ isActive }) => (
              <Box
                as="span"
                padding="md"
                className={isActive ? 'tab-active' : ''}
                hover={{ color: 'primary' }}
                style={{ transitionDuration: '0s', borderBottom: 0 }}
              >
                {adderMap[programType as ProgramType][type as AdderType]}
              </Box>
            )}
          </NavLink>
        ))}
      </Box>
      <Box flex="auto">
        <Routes>
          <Route path=":priceCapType?" element={<PriceCap />} />
        </Routes>
      </Box>
    </Box>
  );
};
